import * as Monitoring from "~/lib/monitoring/client";

type ServerActionContext = Record<string, unknown>;
type ServerActionFailureReporting = "exception" | "warning";
type ServerActionOptions = {
  failureReporting?: ServerActionFailureReporting;
};

export async function callServerActionSafely<T>(
  actionName: string,
  action: () => Promise<T>,
  context?: ServerActionContext,
  options?: ServerActionOptions,
): Promise<T | null> {
  try {
    return await action();
  } catch (error) {
    if (options?.failureReporting === "warning") {
      Monitoring.captureMessage("Best-effort server action response failed", {
        level: "warning",
        tags: {
          client_server_action: actionName,
        },
        extra: {
          ...context,
          errorName: error instanceof Error ? error.name : undefined,
          errorMessage: error instanceof Error ? error.message : String(error),
        },
      });

      return null;
    }

    Monitoring.captureException(error, {
      tags: {
        client_server_action: actionName,
      },
      extra: context,
    });

    return null;
  }
}
